<template>
  <RadioGroup
    v-model="plan"
    class="w-full"
    @update:model-value="updateVariantSelectParams({ type: plan })"
  >
    <div class="flex flex-col gap-2 w-full select-none">
      <div class="flex flex-col items-start lg:flex-row gap-2">
        <RadioGroupOption
          v-slot="{ active, checked }"
          value="subscription"
          as="template"
        >
          <div class="flex-1 w-full basis-1/2">
            <button
              data-gtm-action="select plan"
              data-gtm-label="subscription"
              :class="(active || checked) && 'selected'"
              class="box-button w-full shadow-md"
            >
              <div class="flex justify-between gap-2">
                <span
                  class="button-tag button-tag-top"
                >
                  {{ $t('products.save_on_your_first_order', { percentage: FIRST_TIME_PERCENT }) }}
                </span>
                <h2>
                  <del
                    :aria-label="`Normally ${pricing.onetimePrice}`"
                    class="text-gray-400 mr-1"
                  >
                    {{ pricing.onetimePrice }}
                  </del>
                  {{ pricing.minPrice }}
                  {{ $t('bundler.subscribe_and_save') }}
                </h2>
              </div>
            </button>
            <SubscriptionPricingCheckmarks
              :plan="plan"
              :pricing="pricing"
              :class="plan ==='subscription' ? 'bg-[#ddeecb]' : 'bg-gray-100'"
            />
          </div>
        </RadioGroupOption>
        <RadioGroupOption
          v-slot="{ active, checked }"
          value="onetime"
          as="template"
        >
          <button
            data-gtm-action="select plan"
            data-gtm-label="onetime"
            :class="(active || checked) && 'selected'"
            class="box-button basis-1/2 w-full"
          >
            <div class="flex justify-between gap-2">
              <h2>
                {{ pricing.onetimePrice }}
                {{ $t('bundler.one_time_purchase') }}
              </h2>
            </div>
          </button>
        </RadioGroupOption>
      </div>
    </div>
  </RadioGroup>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
import { RadioGroup, RadioGroupOption } from '@headlessui/vue'
import SubscriptionPricingCheckmarks from '@/components/shared/subscription-pricing-checkmarks.vue'
import { updateVariantSelectParams } from '@/services/bundle-url-params'
import { FIRST_TIME_PERCENT } from '@/utils'
const store = useBundleStore()
const { plan, selectedPricing: pricing } = storeToRefs(store)
</script>

<style>
@reference 'tailwindcss';

.plans-as-rows .md\:flex-row {
  @apply flex-col;
}
</style>
